module.exports = __webpack_public_path__ + "img/info-card-1.75bb8032.jpg";